import React from 'react';
import styles from './styles.module.css';

import {
  Language,
  getText as _getText,
  getImgSrc,
} from '../../core/i18n';
import { croAppsflyerLink as oneLink } from '../../core/config';
import { trackOnce } from '../../core/track';
import { InvitePageProps } from '../App';

const getText = (language: Language, key: string) =>
  _getText(language, `DreamCatcher.${key}`);

function DreamCatcher(props: InvitePageProps) {
  const {
    mid,
    nickname,
    language,
    platform,
  } = props;
  const targetStore = platform === 'android' ? 'google-play' : 'appstore';
  return (
    <div className={styles['invite-page']}>
      <div className={styles['invite-page-wrapper']}>
        <img
          className={styles['key-visual-background']}
          src={getImgSrc(`DreamCatcher/kv-${language}.jpg`)}
          onDragStart={preventDrag}
        />
        <div className={styles['info-box']}>
          {nickname ? (
            (language === 'th') ? (
              <>
                <div
                  className={[
                    styles['gift-from'],
                    styles['gutter-bottom'],
                  ].join(' ')}
                  dangerouslySetInnerHTML={{
                    __html: getText(language, 'gift'),
                  }}
                />
                <div className={styles['gift-from-nickname']}>
                  {nickname}
                </div>
              </>
            ) : (
                <>
                  <div
                    className={[
                      styles['gift-from-nickname'],
                      styles['gutter-bottom'],
                    ].join(' ')}
                  >
                    {nickname}
                  </div>
                  <div
                    className={styles['gift-from']}
                    dangerouslySetInnerHTML={{
                      __html: getText(language, 'gift'),
                    }}
                  />
                </>
              )
          ) : (
              <div
                className={styles['gift-from']}
                dangerouslySetInnerHTML={{
                  __html: getText(language, 'gift_no_name'),
                }}
              />
            )}
        </div>
        <div className={styles['info-box']}>
          <div className={styles['typo-heading']}>
            {getText(language, 'how_to_get_reward')}
          </div>
          <div className={styles['typo-display1']}>
            1
          </div>
          <div className={styles['typo-body1']}>
            {getText(language, 'install_cro')}
            <a href={oneLink} target="_blank">
              <img
                className={styles['invite-page__step1__store-img']}
                src={getImgSrc(targetStore === 'google-play'
                  ? `${targetStore}-download-button/${language}.png`
                  : `${targetStore}-download-button/${language}.svg`
                )}
                onDragStart={preventDrag}
              />
            </a>
          </div>
          <div className={styles['typo-display1']}>
            2
          </div>
          <div
            className={styles['typo-body1']}
            dangerouslySetInnerHTML={{
              __html: getText(language, 'mission'),
            }}
          />
          <div className={styles['typo-display1']}>
            3
          </div>
          <div className={styles['typo-body1']}>
            <div dangerouslySetInnerHTML={{ __html: getText(language, 'claim_reward') }} />
            {getText(language, 'rewards')}
          </div>
        </div>
        <a
          className={styles['claim-button']}
          href={`dsx963067330://host?mid=${mid}`}
          onClick={onClickClaim}
        >
          <img
            className={styles['claim-button-img']}
            src={getImgSrc(`claim-${language}.png`)}
          />
        </a>
        <div className={styles['readme-container']}>
          <div className={styles['readme-heading']}>
            {getText(language, 'condition')}
          </div>
          <div className={styles['readme-body']}>
            <div dangerouslySetInnerHTML={{ __html: getText(language, 'new_player') }} />
            <div dangerouslySetInnerHTML={{ __html: getText(language, 'old_player') }} />
          </div>
        </div>
        <img
          className={styles['logo-img']}
          src={getImgSrc(`logo-${language}.png`)}
        />
      </div>
    </div>
  );
}

function onClickClaim() {
  setTimeout(() => {
    window.open(oneLink, '_blank');
  }, 1000);
  trackOnce('claim');
}

function preventDrag(event: React.DragEvent) {
  event.preventDefault();
}

export default DreamCatcher;
